export default __webpack_public_path__ + "c9d6570378ee69fd6b13f05d9892fa24.png";